import React from 'react';
import { theme } from '../theme';

export const Itinerary = (props) => {
    return (
        <div className="flexColumn flexScroll" style={{padding:'12px 16px',gap:'16px',height:'100%',boxSizing:'border-box',color:theme.navy}}>
                <h3 style={{ margin: '0 0 4px', color: theme.navy, fontSize: 20 }}>8/21 Friday</h3>
                <ul>
                  <li>12:27 PM Practice Round</li>
                  <li style={{marginLeft:50}}>12:27 PM - 1:12 PM Tee Times - in this app</li>
                  <li style={{marginLeft:50}}>Duplicate scoring in this app <br></br>(1 player per 4some)</li>
                  <li>Post-Round -  Check into Hotel / Shower (please)</li>
                  <li>6:30 PM Pizza at Cottage 1 (Hiram Ricker) 39 Cottage Rd  (near 14th Green)</li>
                  <li>7:30 PM Raffle at Cottage 1</li>
                </ul>
                <h3 style={{ margin: '0 0 4px', color: theme.navy, fontSize: 20 }}>8/22 Saturday</h3>
                <ul>
                  <li>8:00 AM - 9:30AM Breakfast Buffet in the Maine Inn</li>
                  <li>10:57 AM Round 1 of Tournament</li>
                  <li style={{marginLeft:50}}>10:57 AM - 11:42 AM Tee Times - in this app</li>
                  <li style={{marginLeft:50}}>Scoring in this app and on card <br></br>(1 player per 4some)</li>
                  <li>Lunch & Dinner are on your own!</li>
                  <li>~ 3:27PM 9 Hole Scramble (immediately follows first round, no prizes)</li>
                  <li>7:30 Beers at Cottage 1.</li>
                </ul>
                <h3 style={{ margin: '0 0 4px', color: theme.navy, fontSize: 20 }}>8/23 Sunday</h3>
                <ul>
                  <li>8:00 AM - 9:30 AM Breakfast Buffet in the Maine Inn</li>
                  <li>9:54 AM Round 2 of Tournament</li>
                  <li style={{marginLeft:50}}>9:54 AM - 10:39 AM Tee Times - view in this app</li>
                  <li style={{marginLeft:50}}>NOTE Tee times for Sunday are determined at the end of Saturday's play.</li>
                  <li style={{marginLeft:50}}>Scoring in this app and on card <br></br>(1 player per 4some)</li>
                  <li>Post-Round - Awards & Group Photo</li>
                  <li>~ 4:00 PM Depart for Home</li>
                </ul>
        </div>
    )
}
